import { toRefs, cloneVNode, watch } from "vue";
function useRenderChildren(props) {
  const {
    internalData,
    visibleData,
    itemRender,
    itemRef
  } = toRefs(props);
  let itemRenderCache = {};
  const internalItemRender = (item, index) => {
    if (!Object.prototype.hasOwnProperty.call(itemRenderCache, index)) {
      [itemRenderCache[index]] = itemRender.value({
        item,
        index
      });
    }
    return itemRenderCache[index];
  };
  const findElement = (node) => {
    var _a;
    let res = (_a = node == null ? void 0 : node.$el) != null ? _a : node;
    while (res && !res.tagName) {
      res = res.nextSibling;
    }
    return res;
  };
  const renderChildren = () => {
    const children = visibleData.value.map(({
      item,
      index,
      key
    }) => {
      const node = internalItemRender(item, index);
      return cloneVNode(node, {
        key,
        ref: (el) => {
          const dom = findElement(el);
          if (dom) {
            itemRef.value(dom, key);
          }
        }
      }, true);
    });
    return children;
  };
  watch([internalData, itemRender], () => {
    itemRenderCache = {};
  });
  return renderChildren;
}
export { useRenderChildren };
